export enum NavSections {
    WELCOME = "welcome",
    CLIP = "clip",
    FEATURES = "features",
    PRICING = "pricing",
    FAQ = "faq",
}

export enum AuthSectionNames {
    LOGIN = 'login',
    REGISTER = 'register'
}

export enum DeveloperSectionNames {
    DEVELOPERS = "developers"
}

export const NavSectionNames: Record<NavSections, string> = {
    [NavSections.WELCOME]: "Home",
    [NavSections.CLIP]: "Clip",
    [NavSections.FEATURES]: "Features",
    [NavSections.PRICING]: "Pricing",
    [NavSections.FAQ]: "FAQ",
}